<template>
  <b-input v-model="displayValue" ref="input" :state="state"/>
</template>

<script>
import baseInput from './_base'

export default {
  mixins: [baseInput],

  data() {
    return {
      displayValue: '',
      selfUpdate: false,
    }
  },

  mounted() {
    this.displayValue = (this.value || {}).formattedAddress
    // TODO: this.$libraryLoaded('googleMaps', () => ...)
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.input.$el, { types: ['geocode'] })
    this.autocomplete.addListener('place_changed', this.addressUpdated)
  },

  watch: {
    value(newVal) {
      this.displayValue = newVal.formattedAddress
    },
  },

  methods: {
    addressUpdated() {
      const place = this.autocomplete.getPlace()
      let streetName, streetNumber, postalCode, city, region
      for (let c in place.address_components) {
        let comp = place.address_components[c]
        switch (comp.types[0]) {
          case 'street_number':
            streetNumber = comp.short_name
            break
          case 'route':
            streetName = comp.short_name
            break
          case 'locality':
            city = comp.long_name
            break
          case 'postal_code':
            postalCode = comp.short_name
            break
          case 'administrative_area_level_1':
            region = comp.long_name
            break
        }
      }

      const location = place.geometry ? place.geometry.location : null
      this.currentValue = {
        formattedAddress: place.formatted_address || "",
        latitude: location ? location.lat() : null,
        longitude: location ? location.lng() : null,
        streetNumber, streetName, city, postalCode, region,
      }

      this.$emit('input', this.currentValue)
    },
  },
}
</script>
